import type { SVGProps } from 'react'
const SvgSyIto = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M5.6 7A1.4 1.4 0 0 1 7 5.6h8A3.4 3.4 0 0 1 18.4 9v8a1.4 1.4 0 0 1-1.4 1.4H7A1.4 1.4 0 0 1 5.6 17z"
		/>
		<path d="M7 5c-1.097 0-2 .903-2 2v10c0 1.097.903 2 2 2h10c1.097 0 2-.903 2-2V9c0-2.202-1.798-4-4-4zm0 1.2h8A2.79 2.79 0 0 1 17.8 9v8c0 .449-.351.8-.8.8H7a.79.79 0 0 1-.8-.8V7c0-.449.351-.8.8-.8" />
		<path d="M8.4 2v4h1.2V2zm0 16v4h1.2v-4zm6 0v4h1.2v-4zm3.6-3.6v1.2h4v-1.2zm-16 0v1.2h4v-1.2zm0-6v1.2h4V8.4zM15 2v1.2a5.8 5.8 0 0 1 4.102 1.698A5.8 5.8 0 0 1 20.8 9H22a7 7 0 0 0-4.32-6.467A7 7 0 0 0 15 2" />
	</svg>
)
export default SvgSyIto
